import * as db from '../../db'
import _ from 'lodash'

export const RECEIVE_BUNDLES = 'RECEIVE_BUNDLES'
export const LOADING_BUNDLES = 'LOADING_BUNDLES'
export const SELECT_BUNDLE = 'SELECT_BUNDLE'
export const CLEAR_BUNDLED_PRODUCTS = 'CLEAR_BUNDLED_PRODUCTS'

// initial state
const state = {
  loading: false,
  bundles: [],
  selectedBundle: {},
  additionalProducts: {
    tvmountxl: '535684000000120218',
    tvmount: '535684000000120209',
    tvMountBundle: 'fivoSDQaSq5F2uQBmdOH',
    standardTvBundle: 'MT1HlppJa4Q2UxQNrtHt'
  }
}

// getters
const getters = {
  bundles: state => _.values(state.bundles),
  loading: state => state.loading,
  selectedBundle: state => state.bundles[state.selectedBundle]
}

// actions
const actions = {
  getBundles({ commit, dispatch }) {
    commit(LOADING_BUNDLES, true)
    db.bundles.onSnapshot(function(snapshot) {
      let bundles = {}
      snapshot.forEach(doc => {
        let bundle = doc.data()
        bundle.id = doc.id
        // dispatch('getTotalBundlePrice', bundle.id).then(price => (bundle.totalPrice = price))
        bundles[bundle.id] = bundle
      })
      commit(RECEIVE_BUNDLES, bundles)
    })
    commit(LOADING_BUNDLES, false)
  },

  updateBundleTotals({ commit, state, dispatch }) {
    _.values(state.bundles).map(bundle => {
      dispatch('getTotalBundlePrice', bundle.id).then(price => (bundle.totalPrice = price))
      return bundle
    })
  },

  getTotalBundlePrice({ state, rootGetters }, bundleId) {
    const bundle = _.values(state.bundles).find(b => b.id === bundleId)
    // console.log("TCL: getTotalBundlePrice -> bundle", bundle)
    let price = 0
    bundle.productBundle.map(productId => {
      let product = rootGetters['item/items'].find(p => p.id === productId)
      // console.log("TCL: getTotalBundlePrice -> product", product)
      price += +product.price
      return price
    })
    return price
  },

  selectBundle({ commit }, selectedBundle) {
    commit(SELECT_BUNDLE, selectedBundle)
  }
}

// mutations
const mutations = {
  [RECEIVE_BUNDLES](state, bundles) {
    state.bundles = bundles
  },
  [SELECT_BUNDLE](state, selectedBundle) {
    state.selectedBundle = selectedBundle
  },
  [LOADING_BUNDLES](state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bundle.js